import GtmService, { GtmEventTypes } from '@/modules/_services/gtm.service'
import { subscriptionTypes, subscriptionTypesGMI } from '@/modules/base/util/constants'
import { isMeinBuero } from '@/utils/build-env'

export const trackOmoSubscriptionSelection = (subscription) => {
  const { name, type } = subscription

  let eventLabel = ''
  switch (name) {
    case subscriptionTypes.FREE_2025:
      eventLabel = `planauswahl_FREE ${type}`
      break
    case subscriptionTypes.XS_2025:
      eventLabel = `planauswahl_XS ${type}`
      break
    case subscriptionTypes.S:
    case subscriptionTypes.S_2021:
    case subscriptionTypes.S_2021_2:
    case subscriptionTypes.S_2025:
    case subscriptionTypesGMI.GMI_S:
    case subscriptionTypes.DOCUMENT_S:
    case subscriptionTypes.STAFF_S:
      eventLabel = `planauswahl_S ${type}`
      break
    case subscriptionTypes.M:
    case subscriptionTypes.M_2021:
    case subscriptionTypes.M_2021_2:
    case subscriptionTypes.M_2025:
    case subscriptionTypesGMI.GMI_M:
    case subscriptionTypes.DOCUMENT_M:
    case subscriptionTypes.STAFF_M:
      eventLabel = `planauswahl_M ${type}`
      break
    case subscriptionTypes.L:
    case subscriptionTypes.L_2021:
    case subscriptionTypes.L_2021_2:
    case subscriptionTypes.L_2025:
    case subscriptionTypesGMI.GMI_L:
    case subscriptionTypes.DOCUMENT_L:
    case subscriptionTypes.STAFF_L:
      eventLabel = `planauswahl_L ${type}`
      break
    case subscriptionTypes.XL_2021:
    case subscriptionTypes.STAFF_XL:
      eventLabel = `planauswahl_Select ${type}`
      break
    case subscriptionTypes.BUCHHALTUNG_2026:
      eventLabel = `planauswahl_BUCHHALTUNG ${type}`
      break
    case subscriptionTypes.AUFTRAG_2026:
      eventLabel = `planauswahl_AUFTRAG ${type}`
      break
    case subscriptionTypes.AUFTRAG_PRO_2026:
      eventLabel = `planauswahl_AUFTRAG_PRO ${type}`
      break
    case subscriptionTypes.WARENWIRTSCHAFT_2026:
      eventLabel = `planauswahl_WARENWIRTSCHAFT ${type}`
      break
    default:
      eventLabel = `planauswahl_${name} ${type}`
  }

  trackOmoSubscription(
    'click_planauswahl',
    eventLabel,
  )
}

export const trackOmoSubscription = (eventAction, eventLabel) => {
  if (isMeinBuero()) return

  GtmService.pushEvent({
    event: GtmEventTypes.GaEventHub,
    eventCategory: 'tester-zu-kauf_funnel',
    eventAction,
    eventLabel,
  })
}
